import styled from 'styled-components';

export default styled.div`
  position: fixed;
  z-index: 9009;
  background-color: rgba(0, 0, 0, 0.7);

  .box {
    position: absolute;
    top: 50px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #ffffff;
    border-radius: 4px;
    box-shadow: ${({ menuShadow }) => menuShadow};
    padding: 37px 40px;
    min-width: 450px;

    p {
      margin: 0;
      margin-bottom: 16px;
      font-size: 18px;
      font-weight: 600;
      line-height: 1.27;
    }

    .action-button {
      padding: 14px 31px;
      font-size: 15px;
    }

    .close-button {
      position: absolute;
      top: 10px;
      right: 10px;
    }
  }
`;
